import React from 'react';

export const CorrectIcon = ({
  width = '16',
  height = '16',
  color = '#000000',
  'aria-hidden': ariaHidden = true,
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    fill={color}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 335.765 335.765"
    aria-hidden={ariaHidden}
    {...rest}
  >
    <g>
      <g>
        <polygon points="311.757,41.803 107.573,245.96 23.986,162.364 0,186.393 107.573,293.962 335.765,65.795 "></polygon>
      </g>
    </g>
  </svg>
);
